import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  HostListener,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { HttpService } from "../../services/http.service";
import { TranslateService } from "@ngx-translate/core";
import { SearchMapComponent } from "../map-view/search/search.component";
import { SearchListComponent } from "../list-view/search/search.component";
import { MapViewComponent } from "../map-view/map-view.component";
import { ListViewComponent } from "../list-view/list-view.component";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-view-area",
  templateUrl: "./view-area.component.html",
  styleUrls: ["./view-area.component.scss"],
})
export class ViewAreaComponent implements OnInit, AfterViewInit {
  //@ViewChild(SearchMapComponent) searchChild: SearchMapComponent;
  //@ViewChild(SearchListComponent) keyword: SearchListComponent;
  //@ViewChild(MapViewComponent) filterMap: MapViewComponent;
  //@ViewChild(MapViewComponent) myLocation: MapViewComponent;
  //@ViewChild(ListViewComponent) filterList: ListViewComponent;
  //@ViewChild(ListViewComponent) searchList: ListViewComponent;

  @ViewChild(SearchMapComponent, { static: true })
  searchChild: SearchMapComponent;
  @ViewChild(SearchListComponent, { static: true })
  keyword: SearchListComponent;
  @ViewChild(MapViewComponent, { static: false }) filterMap: MapViewComponent;
  @ViewChild(MapViewComponent, { static: false }) myLocation: MapViewComponent;
  @ViewChild(ListViewComponent, { static: false })
  filterList: ListViewComponent;
  @ViewChild(ListViewComponent, { static: false })
  searchList: ListViewComponent;

  complete = false;
  showAmbassadors = false;
  showFeedback = false;
  showMap = false;
  showList = false;
  showFilter = false;
  showLegend = false;
  showLanguage = false;
  areas = [];
  elementView;
  lang;
  dataFilter = [];
  startDate;
  endDate;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private httpService: HttpService,
    private translate: TranslateService,
    private title: Title
  ) {}

  ngOnInit() {
    this.startDate = new Date(1544061600000);
    this.endDate = new Date(1544072400000);

    this.title.setTitle("Hushcity");
    if (isPlatformBrowser(this.platformId)) {
      this.lang = sessionStorage.getItem("language");
      if (!sessionStorage.getItem("view-page")) {
        sessionStorage.setItem("view-page", "map-view");
      }
    }
    this.httpService.getQuietAreas(this.lang).subscribe((data) => {
      if (data.err_code === 0) {
        this.areas = data.data.survey;
        this.complete = true;
        if (isPlatformBrowser(this.platformId)) {
          if (sessionStorage.getItem("view-page") === "map-view") {
            this.showMap = true;
          } else {
            this.showList = true;
          }
        }
      } else {
        console.log(data);
      }
    });
  }

  ngAfterViewInit() {
    this.elementView = this.searchChild.element;
  }

  @HostListener("document: click", ["$event.target"]) onClick(targetElement) {
    if (isPlatformBrowser(this.platformId)) {
      const clickedInside = document
        .getElementById("lang-option")
        .contains(targetElement);
      if (!clickedInside) {
        this.showLanguage = false;
      }
    }
  }

  filterAreas(keyword) {
    this.searchList.filterAreas(keyword.trim());
  }

  listView() {
    this.showMap = false;
    this.showList = true;
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem("view-page", "list-view");
    }
  }

  mapView() {
    this.showList = false;
    this.showMap = true;
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem("view-page", "map-view");
    }
  }

  openAmbassadors() {
    this.showLegend = false;
    this.showFilter = false;
    this.showAmbassadors = true;
  }

  closeAmbassadors() {
    this.showAmbassadors = false;
  }

  openFeedback() {
    this.showLegend = false;
    this.showFilter = false;
    this.showFeedback = true;
  }

  closeFeedback() {
    this.showFeedback = false;
  }

  openFilter() {
    this.showLegend = false;
    this.showFilter = !this.showFilter;
  }

  filterClick(event) {
    this.filterMap.filterReceive(event);
    this.filterList.filterReceive(event);
  }

  sendFilter(event) {
    this.showFilter = event;
  }

  closeFilter() {
    this.showFilter = false;
  }

  openLegend() {
    this.showFilter = false;
    this.showLegend = !this.showLegend;
  }

  closeLegend() {
    this.showLegend = false;
  }

  toggleLanguage() {
    this.showFilter = false;
    this.showLegend = false;
    this.showLanguage = !this.showLanguage;
  }

  langEn() {
    this.translate.use("en");
    this.lang = "en";
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem("language", "en");
    }
  }

  langDe() {
    this.translate.use("de");
    this.lang = "de";
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem("language", "de");
    }
  }

  langEs() {
    this.translate.use("es");
    this.lang = "es";
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem("language", "es");
    }
  }

  langIt() {
    this.translate.use("it");
    this.lang = "it";
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem("language", "it");
    }
  }

  langPt() {
    this.translate.use("pt");
    this.lang = "pt";
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem("language", "pt");
    }
  }

  getMyLocation() {
    this.myLocation.getMyLocation();
  }

  setKeyword(event) {
    this.keyword.key = event;
  }
}
